var languages = [
  {
    key: 'en-US',
    name: 'English',
    priority: 1
  },
  {
    key: 'de-DE',
    name: 'Deutsch',
    priority: 2
  },
  {
    key: 'es-ES',
    name: 'Español',
    priority: 3
  },
  {
    key: 'fr-FR',
    name: 'Français',
    priority: 4
  },
  {
    key: 'fr-CA',
    name: 'Français (Canada)',
    priority: 5
  },
  {
    key: 'it-IT',
    name: 'Italiano',
    priority: 6
  },
  {
    key: 'hu-HU',
    name: 'Magyar',
    priority: 7
  },
  {
    key: 'nl-NL',
    name: 'Nederlands',
    priority: 8
  },
  {
    key: 'pt-BR',
    name: 'Português (Br)',
    priority: 9
  },
  {
    key: 'ja-JA',
    name: '日本語',
    priority: 10
  },
  {
    key: 'ko-KO',
    name: '한국어',
    priority: 11
  },
  {
    key: 'zh-CN',
    name: 'Chinese-Simplified',
    priority: 12
  },
  {
    key: 'zh-TW',
    name: 'Chinese-Taiwan',
    priority: 13
  },
  {
    key: 'cs-CZ',
    name: 'Czech',
    priority: 14
  },
  {
    key: 'da-DK',
    name: 'Danish',
    priority: 15
  },
  {
    key: 'fi-FI',
    name: 'Finnish',
    priority: 16
  },
  {
    key: 'nb-NO',
    name: 'Norwegian',
    priority: 17
  },
  {
    key: 'pl-PL',
    name: 'Polish',
    priority: 18
  },
  {
    key: 'ru-RU',
    name: 'Russian',
    priority: 19
  },
  {
    key: 'sv-SE',
    name: 'Swedish',
    priority: 20
  },
  {
    key: 'th-TH',
    name: 'Thai',
    priority: 21
  },
  {
    key: 'tr-TR',
    name: 'Turkish',
    priority: 22
  }
];
